export const countryCodeOptions = [
  { value: '+60', label: '60' },
  { value: '+65', label: '65' },
];
